import { doc, addDoc, collection, setDoc } from "firebase/firestore";
import { db } from "..";

// Add a new document in collection "comments"
const createComment = async (_comment, _userId, _whiskeyId) => {
  const commentRef = doc(collection(db, "comments"))
  const data = {
    comment: _comment,
    userId: _userId,
    whiskeyId: _whiskeyId,
    created: Date.now()
  }
  console.log(data)
  await setDoc(commentRef, data);
  
}

export default createComment